import antdJp from 'antd/lib/locale-provider/ja_JP';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/ja';

import jpMessages from '../locales/ja_JP.json';

const jaLang = {
  messages: {
    ...jpMessages,
  },
  antd: antdJp,
  locale: 'ja-JP',
};
export default jaLang;
